import { useState } from 'react';
import { updateApiConnection } from '../../API/ProtectedAuth';
import { handleApiError } from '../../Utils/errorHandler';

export default function useUpdateApiConnection(connectionId, { onSuccess } = {}) {
  const [values, setValues] = useState({
    provider: '',
    status: 'active'
  });
  const [errors, setErrors] = useState({});
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validate = () => {
    const newErrors = {};
    
    if (!values.provider.trim()) {
      newErrors.provider = 'مزود الخدمة مطلوب';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (!validate()) return;

    setIsLoading(true);

    try {
      await updateApiConnection(connectionId, values);
      setSuccess('تم تحديث اتصال API بنجاح');
      setValues({ provider: '', status: 'active' });
      
      if (onSuccess) {
        setTimeout(() => {
          onSuccess();
        }, 1000);
      }
    } catch (err) {
      const errorMessage = handleApiError(err);
      setError(errorMessage);
      console.error('❌ خطأ في تحديث اتصال API:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    values,
    errors,
    error,
    success,
    isLoading,
    handleChange,
    handleSubmit,
    setValues
  };
}
